var _style, _path, _polygon, _defs, _g, _polygon2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#XMLID_2_);}\n\t.st3{opacity:0.76;fill:#432918;}\n\t.st4{fill:none;stroke:#432918;stroke-width:2.1762;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.86,183.34c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.57,149.04,62.17,183.34,104.86,183.34"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.62,163.32 83.2,163.32 75.91,74.47 135.6,74.47  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_00000117647214278674488330000000585412268149684365_",
    x: 91.96,
    y: 49.85,
    width: 4.69,
    height: 84.09
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000117647214278674488330000000585412268149684365_",
    style: {
      overflow: "visible",
      fill: "#AA1A18"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000117647214278674488330000000585412268149684365_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "99.93,55.84 79.98,62.65 79.52,59.18 99.47,52.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "102.99,78.77 83.04,85.58 82.58,82.11 102.53,75.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "101.46,67.3 81.51,74.12 81.05,70.65 101,63.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.52,90.23 84.57,97.04 84.11,93.57 104.05,86.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "106.05,101.69 86.1,108.5 85.63,105.03 105.58,98.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "107.57,113.15 87.63,119.96 87.16,116.49 107.11,109.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "109.1,124.61 89.15,131.42 88.69,127.95 108.64,121.14  "
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "124.03,156.03 86.9,156.03 82.24,99.54 129.01,99.72  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 108.25,
    cy: 112,
    r: 2.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 101.65,
    cy: 127.25,
    r: 2.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 114.56,
    cy: 138.7,
    r: 2.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCola);
export default __webpack_public_path__ + "static/media/Cola.f553dc0c62611f9042ee784f0aad91de.svg";
export { ForwardRef as ReactComponent };